import * as wishlistConnector from '../../helpers/wishlist-api'

export default {
  state: {
    items: [],
    ready: false,
    initial: true,
  },
  getters: {
    wishlistReady: state => state.ready,
    wishlistContains: state => handle => !!state.items.filter(h => h === handle).length,
    wishlistItems: state => state.items,
    wishlistItemsCount: state => state.items.length,
    wishlistCount: state => state.items.length,
  },
  mutations: {
    setWishlistItems(state, { items, add, initial = false }) {
      if (!initial) {
        state.initial = true
      }

      state.items = items
    },
    setWishlistReady(state) {
      state.ready = true
    },
  },
  actions: {
    loadWishlist({ commit, getters }) {
      if (!getters.isLoggedIn) {
        return commit('setWishlistReady')
      }

      wishlistConnector.loadWishlist(getters.customerId).then(response => {
        commit('setWishlistItems', { items: response.data.items, add: true, initial: true })
        commit('setWishlistReady')
      })
    },
    toggleWishlistItem({ commit, state, getters }, { handle }) {
      if (!state.ready) return

      if (!getters.isLoggedIn) {
        const urlParams = window.location.pathname + location.search
        window.location.href = '/account/login?redirect=' + urlParams
        return
      }

      if (getters.wishlistContains(handle)) {
        wishlistConnector.removeFromWishlist(handle, getters.customerId).then(response => {
          commit('setWishlistItems', { items: response.data.items, add: false })
        })
      } else {
        wishlistConnector.addToWishlist(handle, getters.customerId).then(response => {
          commit('setWishlistItems', { items: response.data.items, add: true })
        })
      }
    },
  },
}
